(function () {
  'use strict';

  if (window.__codexUsConversionLoaded) return;
  window.__codexUsConversionLoaded = true;

  if (window.location.hostname !== 'oukitelpower.com') return;

  var PRODUCT_CONFIG = {
    'oukitel-p1000-plus-portable-power-station': {
      label: 'P1000 Plus',
      useCase: 'Camping, CPAP, and essential devices',
      specs: '1800W output / 1024Wh capacity / fast AC charging'
    },
    'oukitel-p2001-plus-portable-power-station': {
      label: 'P2001 Plus',
      useCase: 'RV, refrigerator, and medium home backup',
      specs: '2400W output / 2048Wh capacity / adjustable AC charging'
    },
    'oukitel-p5000-pro-portable-power-station-5120wh-3600w': {
      label: 'P5000 Pro',
      useCase: 'Heavy-duty appliances and extended home backup',
      specs: '3600W output / 5120Wh capacity / solar bundle options'
    },
    'oukitel-bp5000-pro-max-portable-power-station': {
      label: 'BP5000 Pro Max',
      useCase: 'High-output expandable home backup',
      specs: '5000W output / 5120Wh base capacity / expandable system'
    },
    'oukitel-bp3000-portable-power-station': {
      label: 'BP3000',
      useCase: 'Expandable backup with balanced output and capacity',
      specs: '3200W output / 2048Wh base capacity / expandable system'
    }
  };

  var BLOG_RECOMMENDATIONS = {
    '/blogs/blog/mah-to-kwh-conversion-guide-battery-capacity': [
      'oukitel-p1000-plus-portable-power-station',
      'oukitel-p2001-plus-portable-power-station',
      'oukitel-p5000-pro-portable-power-station-5120wh-3600w'
    ],
    '/blogs/blog/portable-power-station-calculator': [
      'oukitel-p1000-plus-portable-power-station',
      'oukitel-p2001-plus-portable-power-station',
      'oukitel-bp5000-pro-max-portable-power-station'
    ]
  };

  var PRIME_RECOMMENDATIONS = [
    'oukitel-p1000-plus-portable-power-station',
    'oukitel-p5000-pro-portable-power-station-5120wh-3600w',
    'oukitel-bp5000-pro-max-portable-power-station'
  ];

  var productCache = {};

  function currentPath() {
    var path = window.location.pathname.replace(/\/$/, '');
    return path || '/';
  }

  function productHandleFromPath() {
    var match = currentPath().match(/^\/products\/([^/]+)$/);
    return match ? match[1] : '';
  }

  function withPreview(path) {
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!preview) return path;
    var url = new URL(path, window.location.origin);
    url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search + url.hash;
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function formatMoney(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(value % 1 === 0 ? 0 : 2);
    }
  }

  function cardImageUrl(source) {
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      if (url.hostname === 'cdn.shopify.com' || url.hostname === window.location.hostname) {
        url.searchParams.set('width', '760');
      }
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = window.fetch('/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product request failed');
      return response.json();
    }).catch(function () {
      return null;
    });
    return productCache[handle];
  }

  function trackInternalProductClick(link) {
    var detail = {
      event: 'codex_internal_product_click',
      source_path: currentPath(),
      placement: link.getAttribute('data-codex-placement') || 'unknown',
      product_handle: link.getAttribute('data-codex-product-handle') || ''
    };
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('codex:internal-product-click', { detail: detail }));
  }

  function createProductCard(handle, placement) {
    var config = PRODUCT_CONFIG[handle];
    var card = createElement('article', 'codex-us-product-option');
    card.setAttribute('data-codex-product-card', handle);

    var media = createElement('a', 'codex-us-product-option__media');
    media.href = withPreview('/products/' + handle);
    media.setAttribute('data-codex-product-link', '');
    media.setAttribute('data-codex-placement', placement);
    media.setAttribute('data-codex-product-handle', handle);
    media.setAttribute('aria-label', 'View ' + config.label);

    var image = document.createElement('img');
    image.className = 'codex-us-product-option__image';
    image.alt = config.label;
    image.loading = 'eager';
    image.decoding = 'async';
    image.width = 760;
    image.height = 760;
    media.appendChild(image);
    card.appendChild(media);

    var body = createElement('div', 'codex-us-product-option__body');
    body.appendChild(createElement('p', 'codex-us-product-option__use-case', config.useCase));
    body.appendChild(createElement('h3', 'codex-us-product-option__title', config.label));
    body.appendChild(createElement('p', 'codex-us-product-option__copy', config.specs));

    var footer = createElement('div', 'codex-us-product-option__footer');
    var priceWrap = createElement('div', 'codex-us-product-option__price-wrap');
    var status = createElement('span', 'codex-us-product-option__status', 'Checking availability');
    var price = createElement('span', 'codex-us-product-option__price', 'View current price');
    priceWrap.appendChild(status);
    priceWrap.appendChild(price);

    var button = createElement('a', 'codex-us-product-option__button', 'View product');
    button.href = withPreview('/products/' + handle);
    button.setAttribute('data-codex-product-link', '');
    button.setAttribute('data-codex-placement', placement);
    button.setAttribute('data-codex-product-handle', handle);

    footer.appendChild(priceWrap);
    footer.appendChild(button);
    body.appendChild(footer);
    card.appendChild(body);

    fetchProduct(handle).then(function (product) {
      if (!product) {
        status.textContent = 'Check availability';
        status.classList.add('codex-us-product-option__status--check');
        return;
      }
      image.src = cardImageUrl(product.featured_image || (product.images && product.images[0]) || '');
      image.alt = product.title || config.label;
      card.querySelector('.codex-us-product-option__title').textContent = product.title || config.label;
      price.textContent = formatMoney(product.price, product.currency || 'USD');
      status.textContent = product.available ? 'Available to order' : 'Check availability';
      status.classList.toggle('codex-us-product-option__status--check', !product.available);
    });

    return card;
  }

  function createSelector(handles, options) {
    var section = createElement('section', 'codex-us-selector');
    section.setAttribute('data-codex-selector', options.placement);
    section.setAttribute('aria-label', options.title);

    var header = createElement('header', 'codex-us-selector__header');
    header.appendChild(createElement('p', 'codex-us-selector__eyebrow', options.eyebrow));
    header.appendChild(createElement('h2', 'codex-us-selector__title', options.title));
    header.appendChild(createElement('p', 'codex-us-selector__intro', options.intro));
    section.appendChild(header);

    var grid = createElement('div', 'codex-us-selector__grid');
    handles.forEach(function (handle) {
      grid.appendChild(createProductCard(handle, options.placement));
    });
    section.appendChild(grid);
    return section;
  }

  function findProductForm() {
    return document.querySelector(
      '.product-single__form, form[action*="/cart/add"], product-form form, .product-form form'
    );
  }

  function addProductDecisionPanel() {
    var handle = productHandleFromPath();
    var config = PRODUCT_CONFIG[handle];
    if (!config || document.querySelector('.codex-us-decision')) return;

    var form = findProductForm();
    if (!form || !form.parentNode) return;

    var panel = createElement('aside', 'codex-us-decision');
    panel.setAttribute('aria-label', 'United States purchase details');
    panel.appendChild(createElement('p', 'codex-us-decision__eyebrow', 'United States purchase details'));
    panel.appendChild(createElement('h2', 'codex-us-decision__title', config.label + ' buying essentials'));
    panel.appendChild(createElement('p', 'codex-us-decision__specs', config.specs));

    var list = createElement('ul', 'codex-us-decision__list');
    [
      'Current price and bundle availability update from the product page',
      'United States shipping options and timing are confirmed at checkout',
      'Payment options are shown before the order is submitted',
      'Review return and warranty terms before purchasing'
    ].forEach(function (text) {
      list.appendChild(createElement('li', '', text));
    });
    panel.appendChild(list);

    var links = createElement('div', 'codex-us-decision__links');
    var returnsLink = createElement('a', '', 'Return policy');
    returnsLink.href = '/pages/refund-policy';
    var warrantyLink = createElement('a', '', 'Warranty policy');
    warrantyLink.href = '/pages/warranty-policy';
    links.appendChild(returnsLink);
    links.appendChild(warrantyLink);

    if (handle === 'oukitel-p5000-pro-portable-power-station-5120wh-3600w') {
      var compareLink = createElement('a', '', 'Compare P5000');
      compareLink.href = withPreview('/products/oukitel-p5000-portable-power-station');
      compareLink.setAttribute('data-codex-product-link', '');
      compareLink.setAttribute('data-codex-placement', 'p5000_pro_compare');
      compareLink.setAttribute('data-codex-product-handle', 'oukitel-p5000-portable-power-station');
      links.appendChild(compareLink);
    }

    panel.appendChild(links);
    form.parentNode.insertBefore(panel, form);
  }

  function articleContainer() {
    return document.querySelector(
      '.article-section-mid, [itemprop="articleBody"], .article__body, .article__content, article .rte, main article, article'
    );
  }

  // function addBlogRecommendations() {
  //   var handles = BLOG_RECOMMENDATIONS[currentPath()];
  //   if (!handles || document.querySelector('[data-codex-selector="blog_intent"]')) return;

  //   var container = articleContainer();
  //   if (!container) return;
  //   var elements = Array.prototype.slice.call(container.children).filter(function (element) {
  //     return !element.matches('script, style, noscript');
  //   });
  //   var anchor = elements[Math.max(1, Math.floor(elements.length * 0.3))] || elements[0];
  //   var selector = createSelector(handles, {
  //     placement: 'blog_intent',
  //     eyebrow: 'Match the math to a real power station',
  //     title: 'Choose by output and capacity',
  //     intro: 'Compare current prices, availability, and bundle choices before selecting a model.'
  //   });
  //   if (anchor && anchor.parentNode) {
  //     anchor.parentNode.insertBefore(selector, anchor.nextSibling);
  //   } else {
  //     container.insertBefore(selector, container.firstChild);
  //   }

  //   var endLink = createElement('aside', 'codex-us-end-link');
  //   endLink.appendChild(createElement('p', '', 'Ready to compare a practical option with your calculation?'));
  //   var link = createElement('a', '', 'Review ' + PRODUCT_CONFIG[handles[0]].label);
  //   link.href = withPreview('/products/' + handles[0]);
  //   link.setAttribute('data-codex-product-link', '');
  //   link.setAttribute('data-codex-placement', 'blog_end');
  //   link.setAttribute('data-codex-product-handle', handles[0]);
  //   endLink.appendChild(link);
  //   container.appendChild(endLink);
  // }

  // function addPrimeRecommendations() {
  //   if (currentPath() !== '/pages/prime-days-sale' || document.querySelector('[data-codex-selector="prime_days"]')) return;
  //   var main = document.querySelector('main, #MainContent');
  //   if (!main) return;
  //   var selector = createSelector(PRIME_RECOMMENDATIONS, {
  //     placement: 'prime_days',
  //     eyebrow: 'United States model finder',
  //     title: 'Choose by power level',
  //     intro: 'Current product prices and availability load directly from the store. Open a product to review its active bundles.'
  //   });
  //   var firstSection = main.querySelector('.shopify-section, section');
  //   if (firstSection && firstSection.parentNode) {
  //     firstSection.parentNode.insertBefore(selector, firstSection.nextSibling);
  //   } else {
  //     main.insertBefore(selector, main.firstChild);
  //   }
  // }

  function productAddButton() {
    var form = findProductForm();
    if (!form) return null;
    return form.querySelector('button.add-to-cart, button[type="submit"], input[type="submit"]');
  }

  function createStickyCta() {
    if (document.querySelector('.codex-us-sticky')) return;
    var handle = productHandleFromPath();
    var blogHandles = BLOG_RECOMMENDATIONS[currentPath()];
    var mode = PRODUCT_CONFIG[handle] ? 'product' : (blogHandles ? 'blog' : '');
    // 新增：产品页、博客页全部禁止生成悬浮条
  if (mode === 'product' || mode === 'blog') return;
  if (!mode) return;

    var targetHandle = mode === 'product' ? handle : blogHandles[0];
    var config = PRODUCT_CONFIG[targetHandle];
    var bar = createElement('div', 'codex-us-sticky');
    bar.setAttribute('data-codex-sticky-mode', mode);

    var label = createElement('div', 'codex-us-sticky__label');
    label.appendChild(createElement('span', 'codex-us-sticky__title', mode === 'product' ? config.label : 'Compare power stations'));
    var meta = createElement('span', 'codex-us-sticky__meta', mode === 'product' ? config.specs : 'Current prices and availability');
    label.appendChild(meta);

    var button = createElement(mode === 'product' ? 'button' : 'a', 'codex-us-sticky__button', mode === 'product' ? 'Add to cart' : 'Compare models');
    if (mode === 'product') {
      button.type = 'button';
      button.addEventListener('click', function () {
        var target = productAddButton();
        if (target) target.click();
      });
      fetchProduct(handle).then(function (product) {
        if (product) meta.textContent = formatMoney(product.price, product.currency || 'USD') + ' / ' + config.specs;
      });
    } else {
      button.href = withPreview('/products/' + targetHandle);
      button.setAttribute('data-codex-product-link', '');
      button.setAttribute('data-codex-placement', 'blog_sticky');
      button.setAttribute('data-codex-product-handle', targetHandle);
    }

    bar.appendChild(label);
    bar.appendChild(button);
    document.body.appendChild(bar);
  }

  function syncStickyCta() {
    var bar = document.querySelector('.codex-us-sticky');
    if (!bar) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var drawerOpen = !!document.querySelector('#CartDrawer.drawer--is-open, cart-drawer.active, .drawer--is-open');
    document.body.classList.toggle('codex-hide-us-sticky', drawerOpen);
    if (!isMobile || drawerOpen || window.scrollY < 420) {
      bar.classList.remove('is-visible');
      return;
    }

    if (bar.getAttribute('data-codex-sticky-mode') === 'product') {
      var form = findProductForm();
      if (form) {
        var rect = form.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 80) {
          bar.classList.remove('is-visible');
          return;
        }
      }
    }
    bar.classList.add('is-visible');
  }

  function init() {
    addProductDecisionPanel();
    // addBlogRecommendations();
    // addPrimeRecommendations();
    createStickyCta();
    syncStickyCta();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-codex-product-link]');
    if (link) trackInternalProductClick(link);
    window.setTimeout(syncStickyCta, 150);
    window.setTimeout(syncStickyCta, 700);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.setTimeout(init, 1500);
  window.setTimeout(init, 5000);

  window.addEventListener('scroll', syncStickyCta, { passive: true });
  window.addEventListener('resize', syncStickyCta);
})();
